import { useGetDispositionMethodList } from '@/views/screens/Claims/PreClaims/hooks';

import FormSelectBox from '../../../../../components/Inputs/FormSelectBox';

export const ClaimsDispositionMethodSelect = ({
  placeholder = 'Disposition Method',
  label = 'Enter Disposition Method',
  rules = [],
  name,
  editMode,
  margin,
  onChange,
  value = '',
  className = '',
  tabIndex,
  mode = '',
  disableValidation = false,
}) => {
  const { data: options = [], isLoading } = useGetDispositionMethodList();

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      onChange={onChange}
      value={value}
      mode={mode}
      className={className}
      tabIndex={tabIndex}
      disableValidation={disableValidation}
      shouldUseNativeSelect
    />
  );
};
